import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { analyticsService } from './analyticsService';

// Service pour gérer les contacts
export const contactService = {
  // Ajouter un nouveau contact
  async addContact(contactData) {
    try {
      const docRef = await addDoc(collection(db, 'contacts'), {
        ...contactData,
        timestamp: serverTimestamp(),
        status: 'new'
      });
      
      // Tracer l'événement analytics
      analyticsService.trackFormSubmission(contactData.source, contactData);
      
      return {
        success: true,
        id: docRef.id,
        message: 'Contact enregistré avec succès'
      };
    } catch (error) {
      console.error('Erreur lors de l\'ajout du contact:', error);
      throw new Error('Erreur lors de l\'enregistrement du contact');
    }
  },

  // Valider les données du contact
  validateContact(contactData) {
    const { firstName, lastName, phone, email } = contactData;
    const errors = [];

    if (!firstName || firstName.trim() === '') {
      errors.push('Le prénom est requis');
    }

    if (!lastName || lastName.trim() === '') {
      errors.push('Le nom est requis');
    }

    if (!phone || phone.trim() === '') {
      errors.push('Le téléphone est requis');
    }

    if (!email || email.trim() === '') {
      errors.push('L\'email est requis');
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.push('Format d\'email invalide');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }
};
